import { LayoutManagerService } from './services/layout/layout-manager.service';

import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { WsService } from '../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';

import {
  RoomManagerService,
  OnPeer
} from './services/room/room-manager.service';
import { SessionManagerService } from './services/session/session-manager.service';
import {
  UserTypeManagerService,
  UserType
} from './services/usertype/user-type-manager.service';
import { DesksService } from './desksmenu/desks.service';

import { RecordingManagerService } from './services/recording/recording-manager.service';
import { OnRecording } from './services/recording/recording-manager';
import { Modal } from 'ng2-modal';
import { WbService } from './wb.service';

import { environment } from '../../environments/environment';
import { PermissionsManagerService } from './services/permissions/permissions-manager.service';
import { ActivatedRoute } from '@angular/router';
import { Layout } from './services/layout/layout-manager';
declare var $;

declare var Tour;
@Component({
  selector: 'dskl-wb-status',
  templateUrl: 'wb-status.component.html',
  styleUrls: ['wb-status.component.css']
})
export class WbStatusComponent implements AfterViewInit, OnDestroy {
  public showIntro = true;
  constructor(
    private permissionService: PermissionsManagerService,
    private desksService: DesksService,
    private translateService: TranslateService,
    private sessionManager: SessionManagerService,
    private userTypeManager: UserTypeManagerService,
    private roomManagerService: RoomManagerService,
    private wsService: WsService,
    private wbService: WbService,
    private recordingManagerService: RecordingManagerService,
    private layoutService: LayoutManagerService,
    private route: ActivatedRoute
  ) {
    if (!this.route.snapshot.url[0].path.startsWith('recorder')) {
      this.showIntro = false;
    }
  }
  @Input() pageName = '';
  @Input() board;
  @Input() boardsCount = 0;
  @Output() helpPressed = new EventEmitter();
  @ViewChild('playermanager') playerManager;
  @ViewChild('mediacontrol') mediacontrol;
  
  @ViewChild('materials') materials;@ViewChild('close') close;
  
  @ViewChild('sharescreen') sharescreen;
  @ViewChild("addTask") addTask: Modal;

  openPlayerManager() {
    this.playerManager.open();
  }
  help(e) {
    if (this.route.snapshot.url[0].path.startsWith('recorder')) {
      this.startTour();
    } else {
      this.helpPressed.emit(e);
    }
  }
  getSessions() {
    return this.sessionManager.sessions;
  }
  hasContentModule() {
    return environment.contentModule && !this.wbService.isDemo();
  }
  shouldBeHidden() {
    return this.boardsCount == 2;
  }
  isFirstBoard() {
    return this.board.column == 1;
  }
  canUseTools() {
    return (
      this.permissionService.canUseTools() ||
      this.recordingManagerService.allowRecording
    );
  }
  isTeacher() {
    return this.userTypeManager.getType() == UserType.TEACHER;
  }
  ngOnDestroy() {
    this.roomManagerService.unregisterCallback(this);
  }
  openWbStatus() {
    $('#wb-status.wb-status').toggleClass('open');
    $('#bottomtools').toggleClass('open', false);
  }
  openMediaControl(){
    this.mediacontrol.open()
    setTimeout(function(){
      $(".modal-backdrop").hide();
    }, 500)
  }
  openPlugin(){
    this.sharescreen.open()
    setTimeout(function(){
      $(".modal-backdrop").hide();
    }, 4000)
  }
  openMaterials(){
    this.materials.open()
    setTimeout(function(){
      $(".modal-backdrop").hide();
    }, 500)
  }
  openClose(){
    this.close.open()
    setTimeout(function(){
      $(".modal-backdrop").hide();
    }, 500)
  }
  addTaskOpen(){
    console.log("Working ipeninng");
    this.addTask.open()
    setTimeout(function(){
      $(".modal-backdrop").hide();
    }, 500)
  }
  private setColors(
    image,
    btnsBackgrounColor,
    btnsBackgrounBorder,
    lanesBackgrounColor
  ) {
    
    if (environment.color){
      $('#peers').css('background', "url('" + image + "')");
    }else{
     // if (this.layoutService.getLayout()==Layout.AUDIO_WB){
          $('#peers').css('background', "url('" + image + "') 0px 42px/contain no-repeat");
      /*}else{
          $('#peers').css('background', "none");
      }*/
    }
    $('footer .btn-success, footer .btn-primary, footer .btn-warning, .wrapper .btn-warning').css(
      'background-color',
      btnsBackgrounColor
    );

    if (!environment.color){
      
      $('footer .btn-primary, footer .btn-warning, .wrapper .btn-warning').css(
      'color', '#000' );
    $('footer .btn-success').css('color', '#f00');
    }
    $('footer .btn-success, footer .btn-primary, footer .btn-warning, .wrapper .btn-warning').css(
      'border-color',
      btnsBackgrounBorder
    );

    $('.lane .btn-success, .lane .btn-primary, .lane .btn-warning').css(
      'background-color',
      btnsBackgrounColor
    );
    $('.lane .btn-success, .lane .btn-primary, .lane .btn-warning').css(
      'border-color',
      btnsBackgrounBorder
    );
    $('footer').css("box-shadow","rgba(0, 0, 0, 0.2) 0px 5px 25px 2px");
    
    // $(".lane,footer").css("backgrecordingManagerService.allowRecordinground-color", lanesBackgrounColor);
    $('.lane,footer').css('background-color', lanesBackgrounColor);
    console.log(
      'linear-gradient(to right,' +
        btnsBackgrounColor +
        ' 0%, ' +
        btnsBackgrounColor +
        ' 33.33%,  ' +
        btnsBackgrounBorder +
        ' 33.34%, ' +
        btnsBackgrounBorder +
        ' 66.66%,  ' +
        lanesBackgrounColor +
        ' 66.67%, ' +
        lanesBackgrounColor +
        ' 100%)'
    );
    $('#chat-header').css(
      'background',
      'linear-gradient(to left,' +
        btnsBackgrounColor +
        ' 0%, ' +
        btnsBackgrounColor +
        ' 33.33%,  ' +
        btnsBackgrounBorder +
        ' 33.34%, ' +
        btnsBackgrounBorder +
        ' 66.66%,  ' +
        lanesBackgrounColor +
        ' 66.67%, ' +
        lanesBackgrounColor +
        ' 100%)'
    );
  }
  shouldBeFixed() {
    return this.shouldBeHidden() && !this.isFirstBoard();
  }

  ngAfterViewInit() {
    if (this.board) {
      var color;
      if (environment.color){
      switch (this.board.wbType) {
        case 'CHAT':
        case 'FABRIC':
          color = 'orange';
          
          this.setColors(
            'assets/images/a1.png',
            "#eea236", "#f0ad4e", "#ffddad"
          );
          break;

        case 'ALGEBRA':
          color = '#337ab7';
          this.setColors(
            'assets/images/a2.png',
            '#2e6da4',
            '#337ab7',
            '#d9edf7'
          );
          break;
        case 'GRAPHIC':
          color = '#9962ba';
          $('.horz-toolbar').css('background-color', '#f6c2ff');
          this.setColors(
            'assets/images/purple.jpg',
            '#9962ba',
            '#c07fe7',
            '#f6c2ff'
          );
          break;
        case 'LINK_YOUTUBE':
          color = '#423ee6';
          this.setColors(
            'assets/images/darkblue.jpg',
            '#423ee6',
            '#6965f3',
            '#cbc9fb'
          );
          break;
        case 'MEDIA':
          color = '#5d0827';
          this.setColors(
            'assets/images/media.jpg',
            '#5d0827',
            '#861d43',
            '#f581ae'
          );
          break;
        case 'GEOMETRY':
          color = '#5d0827';
          this.setColors(
            'assets/images/media.jpg',
            '#5d0827',
            '#861d43',
            '#f581ae'
          );
          break;
        case 'TEXT':
          color = '#337ab7';
          this.setColors(
            'assets/images/a2.png',
            '#2e6da4',
            '#337ab7',
            '#d9edf7'
          );
          break;
        case 'CODE':
          color = '#423ee6';
          this.setColors(
            'assets/images/darkblue.jpg',
            '#423ee6',
            '#6965f3',
            '#cbc9fb'
          );
          break;

        case 'GEOGEBRA':
          color = '#9962ba';
          this.setColors(
            'assets/images/purple.jpg',
            '#9962ba',
            '#c07fe7',
            '#f6c2ff'
          );
          break;
      }
      $(".status-mts").css("margin-top", "0");
    }
      else{
        $(".status-mts").css("margin-top", "30px");
        $(".wb-status > *").css("height","36px");
        $(".wb-status > *").css("color","#000");
        
      this.setColors(
        environment.logo,
        '#ffffff',
        '#ffffff',
        '#ffffff'
      );
      $(".two-boards button").css("box-shadow", "none");
      $(".two-boards button").css("border-color", "white");
      $(".two-boards button").css("width", "35");
      $(".two-boards button:hover").css("background-color", "white");
        $(".lane button").addClass("icon-mts");
      // $(".lane").css("box-shadow", "rgba(0, 0, 0, 0.2) 0px 0px 17px 1px");
      // $(".lane").css("margin", "30px");
      }
      if (color) this.layoutService.setCurrentColor(color);
      
      this.color = color;
      
    }
  }
  ///@Input() canGoBack;
  //@Input() sessionId;
  // @Input() groupId;
  color;
  recordingColor() {
    return this.isRecording() ? 'red' : '';
  }
  getSessionRecordingLabel() {
    return this.isRecording()
      ? 'DSKL_BUTTON_TOOLTIP.SESSION_RECORDING_STOP'
      : 'DSKL_BUTTON_TOOLTIP.SESSION_RECORDING_START';
  }
  showStatus() {
    return this.board.wbType != 'WELCOME';
  }

  getLabel() {
    return this.desksService.getDescValue(this.board.wbType);
  }
  @Input() showMoreDropdown = true;
  backToGroups() {
    console.log('Calling back to groups ');
    this.sessionManager.onExitFromGroup();
  }
  shouldShowLabel() {
    return true;
  }

  newPage() {
    this.sessionManager.createPage(
      this.board.column,
      this.board.boardId,
      this.board.wbType,
      false
    );
  }
  /*
     selectedDesk(o) {
         console.log("Selected desk ", o.desk.value);
         this.sessionManager.changeDesk(this.board.column, this.board.boardId, o.desk.value)

     }*/
  isRecording() {
    return this.demoRecording || this.recordingManagerService.isRecording();
  }
  demoRecording = false;
  onRecording() {
    if (this.wbService.isDemo()) {
      this.demoRecording = !this.demoRecording;
    } else {
      this.recordingManagerService.switchRecording();
    }
  }

  hideVideos() {
    var self = this;
    this.layoutService.onHideVideos();
    setTimeout(function() {
      self.layoutService.resize();
    }, 200);
  }

  showSettings() {
    $('#wb-status').toggleClass('active');
  }

  tour;
  startTour() {
    this.tour = new Tour({
      storage: false,
      template:
        "<div class='popover tour'>  <div class='arrow'></div><h3 class='popover-title'></h3><div class='popover-content'></div>  <div class='popover-navigation'> <button class='btn btn-default' data-role='prev'>« </button> <span data-role='separator'>|</span> <button class='btn btn-default' data-role='next'> »</button><button class='btn btn-default' data-role='end'>X</button> </div> </div>",
      //backdrop: true,
      // backdropContainer: 'body',
      //backdropPadding: 0,
      steps: [
        {
          smartPlacement: true,
          element: '#recorder-step',
          content: this.translateService.instant('TUTORIAL_STEPS.RECORDER_STEP')
        },
        {
          smartPlacement: true,
          element: '#recorded-content-step',
          content: this.translateService.instant(
            'TUTORIAL_STEPS.RECORDED_CONTENT_STEP'
          )
        },
        {
          smartPlacement: true,
          element: '#change-desks',
          content: this.translateService.instant(
            'TUTORIAL_STEPS.CHANGE_DESKS_STEP'
          )
        },
        {
          smartPlacement: true,
          element: '#materials-btn',
          content: this.translateService.instant(
            'TUTORIAL_STEPS.MATERIALS_BTN_STEP'
          )
        },
        {
          smartPlacement: true,
          element: '#share-screen-btn',
          content: this.translateService.instant(
            'TUTORIAL_STEPS.SHARE_SCREEN_BTN_STEP'
          )
        },
        {
          smartPlacement: true,
          element: '#single-button',
          content: this.translateService.instant(
            'TUTORIAL_STEPS.NEW_LESSON_BTN_STEP'
          )
        },
        {
          smartPlacement: true,
          element: '#help-btn',
          content: this.translateService.instant('TUTORIAL_STEPS.HELP_BTN_STEP')
        },
        {
          smartPlacement: true,
          element: '#exit-step',
          content: this.translateService.instant('TUTORIAL_STEPS.EXIT_BTN_STEP')
        }
      ]
    });
    // Start the tour
    this.tour.start();
  }

  startRecordedTour() {
    setTimeout(() => {
      console.log('tourrr');
      this.tour = new Tour({
        storage: false,
        template:
          "<div class='popover tour'>  <div class='arrow'></div><h3 class='popover-title'></h3><div class='popover-content'></div>  <div class='popover-navigation'> <button class='btn btn-default' data-role='prev'>« </button> <span data-role='separator'>|</span> <button class='btn btn-default' data-role='next'> »</button><button class='btn btn-default' data-role='end'>X</button> </div> </div>",
        //backdrop: true,
        // backdropContainer: 'body',
        //backdropPadding: 0,
        steps: [
          {
            // smartPlacement: true,
            placement: 'top',
            element: '#working-files-steps',
            content: this.translateService.instant('RECORDED_FILES_STEPS.FILES')
          },
          {
            placement: 'top',
            element: '#names-step0',
            content: this.translateService.instant(
              'RECORDED_FILES_STEPS.CHANGE_NAME'
            )
          },
          {
            placement: 'top',
            element: '#play-step0',
            content: this.translateService.instant(
              'RECORDED_FILES_STEPS.PLAY_STEP'
            )
          },
          {
            placement: 'top',
            element: '#delete-step0',
            content: this.translateService.instant(
              'RECORDED_FILES_STEPS.DELETE_STEP'
            )
          },
          {
            placement: 'bottom',
            element: '#publish-step0',
            content: this.translateService.instant(
              'RECORDED_FILES_STEPS.PUBLISH_STEP'
            )
          },
          {
            placement: 'left',
            element: '#close-step',
            content: this.translateService.instant(
              'RECORDED_FILES_STEPS.CLOSE_STEP'
            )
          }
        ]
      });

      // Initialize the tour
      this.tour.init();
      // Start the tour
      this.tour.start();
    }, 500);
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/wb-status.component.ts